import { useMutation, useQueryClient } from "@tanstack/react-query";
import { logout } from "@/lib/pocketbase";

export const useLogout = () => {
	const queryClient = useQueryClient();

	return useMutation({
		mutationFn: () => {
			queryClient.clear();
			return logout();
		},
	});
};
